module.exports = __webpack_public_path__ + "img/FamilyInteraction.d24408ba.png";